// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

let i = 0;
document.querySelectorAll('.program-swiper').forEach(el => {
  i++;
  let next = el.parentElement.parentElement.querySelector('.swiper-button-next');
  let prev = el.parentElement.parentElement.querySelector('.swiper-button-prev');
  el.classList.add('program-swiper-' + i);
  next.classList.add('program-btn-next-' + i);
  prev.classList.add('program-btn-prev-' + i);

  let swiper = new Swiper('.program-swiper-' + i, {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    // Optional parameters
    // Responsive breakpoints

    breakpoints: {
      // when window width is >= 576px
      576: {
        slidesPerView: 2,
        spaceBetween: -1
      },
      // when window width is >= 767px
      767: {
        slidesPerView: 2,
        spaceBetween: -1
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 3,
        spaceBetween: -1
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        spaceBetween: -1
      },
      // when window width is >= 1200px
      1400: {
        slidesPerView: 4,
        spaceBetween: -1
      },
    },

    loop: false,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.program-btn-next-' + i,
      prevEl: '.program-btn-prev-' + i,
    }
  });
});

document.querySelectorAll('.detail-program-toggle').forEach(button => {
  button.addEventListener('click', () => {
    let container = button.parentNode;
    let items = container.querySelectorAll('.mobile-film-detail-time-item');
    const isExpanded = button.classList.contains('expanded');

    if (isExpanded) {
      // collapse back → hide all except first two
      items.forEach((item, index) => {
        if (index > 1) {
          item.classList.remove('active');
          item.classList.add('hidden');
        }
      });
      button.classList.remove('expanded');
      button.ariaExpanded = 'false';
      container.scrollIntoView()
      button.textContent = 'ganze woche zeigen';
    } else {
      // expand → show all
      items.forEach(item => {
        item.classList.remove('hidden');
        item.classList.add('active');
      });
      button.classList.add('expanded');
      button.ariaExpanded = 'true';
      button.textContent = 'nur heute und morgen zeigen';
    }
  });
});
